import { APP_BUNDLES, EXAM_TITLES, BUNDLE_APP_NAME, IS_BUNDLE_APP } from './_shared/brand-data'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_A_220_1201,
  PRACTICE_TEST as PRACTICE_TEST_A_220_1201,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_A_220_1201,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_A_220_1201,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_A_220_1201,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_A_220_1201,
} from './220-1201'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_A_220_1202,
  PRACTICE_TEST as PRACTICE_TEST_A_220_1202,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_A_220_1202,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_A_220_1202,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_A_220_1202,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_A_220_1202,
} from './220-1202'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CLOUD_CV0_004,
  PRACTICE_TEST as PRACTICE_TEST_CLOUD_CV0_004,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CLOUD_CV0_004,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CLOUD_CV0_004,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CLOUD_CV0_004,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CLOUD_CV0_004,
} from './Cloud+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CYSA_CS0_003,
  PRACTICE_TEST as PRACTICE_TEST_CYSA_CS0_003,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CYSA_CS0_003,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CYSA_CS0_003,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CYSA_CS0_003,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CYSA_CS0_003,
} from './CySA+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_DATASYS_DS0_001,
  PRACTICE_TEST as PRACTICE_TEST_DATASYS_DS0_001,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_DATASYS_DS0_001,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_DATASYS_DS0_001,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_DATASYS_DS0_001,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_DATASYS_DS0_001,
} from './DataSys+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_DATAX_DX0_001,
  PRACTICE_TEST as PRACTICE_TEST_DATAX_DX0_001,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_DATAX_DX0_001,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_DATAX_DX0_001,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_DATAX_DX0_001,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_DATAX_DX0_001,
} from './DATAX'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_LINUX_XK0_006,
  PRACTICE_TEST as PRACTICE_TEST_LINUX_XK0_006,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_LINUX_XK0_006,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_LINUX_XK0_006,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_LINUX_XK0_006,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_LINUX_XK0_006,
} from './Linux+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_NETWORK_N10_009,
  PRACTICE_TEST as PRACTICE_TEST_NETWORK_N10_009,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_NETWORK_N10_009,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_NETWORK_N10_009,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_NETWORK_N10_009,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_NETWORK_N10_009,
} from './Network+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_PENTEST_PT0_003,
  PRACTICE_TEST as PRACTICE_TEST_PENTEST_PT0_003,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_PENTEST_PT0_003,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_PENTEST_PT0_003,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_PENTEST_PT0_003,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_PENTEST_PT0_003,
} from './PenTest+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_PROJECT_PK0_005,
  PRACTICE_TEST as PRACTICE_TEST_PROJECT_PK0_005,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_PROJECT_PK0_005,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_PROJECT_PK0_005,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_PROJECT_PK0_005,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_PROJECT_PK0_005,
} from './Project+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SECURITY_SY0_701,
  PRACTICE_TEST as PRACTICE_TEST_SECURITY_SY0_701,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SECURITY_SY0_701,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SECURITY_SY0_701,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SECURITY_SY0_701,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_SECURITY_SY0_701,
} from './Security+'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERVER_SK0_005,
  PRACTICE_TEST as PRACTICE_TEST_SERVER_SK0_005,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERVER_SK0_005,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERVER_SK0_005,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERVER_SK0_005,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_SERVER_SK0_005,
} from './Server+'


import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export { APP_BUNDLES, BUNDLE_APP_NAME, IS_BUNDLE_APP }

export const APP_DATA = {
  DISPLAY_APP_NAME: 'CompTIA Cert Prep',
};



export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'A+ 220-1201';
};

export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'A+ 220-1201';
}

const APP_NAME = "CompTIA";






export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'A+ 220-1201';
};



const QUESTION_VERSIONS = {
  '220-1201': QUESTION_VERSION_OF_JSON_A_220_1201,
  '220-1202': QUESTION_VERSION_OF_JSON_A_220_1202,
  'Cloud+': QUESTION_VERSION_OF_JSON_CLOUD_CV0_004,
  'CySA+': QUESTION_VERSION_OF_JSON_CYSA_CS0_003,
  'DataSys+': QUESTION_VERSION_OF_JSON_DATASYS_DS0_001,
  'DATAX': QUESTION_VERSION_OF_JSON_DATAX_DX0_001,
  'Linux+': QUESTION_VERSION_OF_JSON_LINUX_XK0_006,
  'Network+': QUESTION_VERSION_OF_JSON_NETWORK_N10_009,
  'PenTest+': QUESTION_VERSION_OF_JSON_PENTEST_PT0_003,
  'Project+': QUESTION_VERSION_OF_JSON_PROJECT_PK0_005,
  'Security+': QUESTION_VERSION_OF_JSON_SECURITY_SY0_701,
  'Server+': QUESTION_VERSION_OF_JSON_SERVER_SK0_005
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_A_220_1201;
};



export const app_url = "https://www.learnzapp.com/apps/comptia";

const PRACTICE_TESTS = {
  '220-1201': PRACTICE_TEST_A_220_1201,
  '220-1202': PRACTICE_TEST_A_220_1202,
  'Cloud+': PRACTICE_TEST_CLOUD_CV0_004,
  'CySA+': PRACTICE_TEST_CYSA_CS0_003,
  'DataSys+': PRACTICE_TEST_DATASYS_DS0_001,
  'DATAX': PRACTICE_TEST_DATAX_DX0_001,
  'Linux+': PRACTICE_TEST_LINUX_XK0_006,
  'Network+': PRACTICE_TEST_NETWORK_N10_009,
  'PenTest+': PRACTICE_TEST_PENTEST_PT0_003,
  'Project+': PRACTICE_TEST_PROJECT_PK0_005,
  'Security+': PRACTICE_TEST_SECURITY_SY0_701,
  'Server+': PRACTICE_TEST_SERVER_SK0_005
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_A_220_1201;
};

const DOMAIN_LISTS = {
  '220-1201': APP_DOMAIN_LIST_A_220_1201,
  '220-1202': APP_DOMAIN_LIST_A_220_1202,
  'Cloud+': APP_DOMAIN_LIST_CLOUD_CV0_004,
  'CySA+': APP_DOMAIN_LIST_CYSA_CS0_003,
  'DataSys+': APP_DOMAIN_LIST_DATASYS_DS0_001,
  'DATAX': APP_DOMAIN_LIST_DATAX_DX0_001,
  'Linux+': APP_DOMAIN_LIST_LINUX_XK0_006,
  'Network+': APP_DOMAIN_LIST_NETWORK_N10_009,
  'PenTest+': APP_DOMAIN_LIST_PENTEST_PT0_003,
  'Project+': APP_DOMAIN_LIST_PROJECT_PK0_005,
  'Security+': APP_DOMAIN_LIST_SECURITY_SY0_701,
  'Server+': APP_DOMAIN_LIST_SERVER_SK0_005
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_A_220_1201;
};

const STUDY_QUESTION_MENUS = {
  '220-1201': GET_STUDY_QUESTION_MENU_A_220_1201,
  '220-1202': GET_STUDY_QUESTION_MENU_A_220_1202,
  'Cloud+': GET_STUDY_QUESTION_MENU_CLOUD_CV0_004,
  'CySA+': GET_STUDY_QUESTION_MENU_CYSA_CS0_003,
  'DataSys+': GET_STUDY_QUESTION_MENU_DATASYS_DS0_001,
  'DATAX': GET_STUDY_QUESTION_MENU_DATAX_DX0_001,
  'Linux+': GET_STUDY_QUESTION_MENU_LINUX_XK0_006,
  'Network+': GET_STUDY_QUESTION_MENU_NETWORK_N10_009,
  'PenTest+': GET_STUDY_QUESTION_MENU_PENTEST_PT0_003,
  'Project+': GET_STUDY_QUESTION_MENU_PROJECT_PK0_005,
  'Security+': GET_STUDY_QUESTION_MENU_SECURITY_SY0_701,
  'Server+': GET_STUDY_QUESTION_MENU_SERVER_SK0_005
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_A_220_1201;
  let menu = menuFn();
  
  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      icon_bg: '#E6E6FA',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }
  
  return menu;
};

const FLASH_CARD_MENUS = {
  '220-1201': GET_FLASH_CARD_MENU_A_220_1201,
  '220-1202': GET_FLASH_CARD_MENU_A_220_1202,
  'Cloud+': GET_FLASH_CARD_MENU_CLOUD_CV0_004,
  'CySA+': GET_FLASH_CARD_MENU_CYSA_CS0_003,
  'DataSys+': GET_FLASH_CARD_MENU_DATASYS_DS0_001,
  'DATAX': GET_FLASH_CARD_MENU_DATAX_DX0_001,
  'Linux+': GET_FLASH_CARD_MENU_LINUX_XK0_006,
  'Network+': GET_FLASH_CARD_MENU_NETWORK_N10_009,
  'PenTest+': GET_FLASH_CARD_MENU_PENTEST_PT0_003,
  'Project+': GET_FLASH_CARD_MENU_PROJECT_PK0_005,
  'Security+': GET_FLASH_CARD_MENU_SECURITY_SY0_701,
  'Server+': GET_FLASH_CARD_MENU_SERVER_SK0_005
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_A_220_1201;
  return menuFn();
};

const ARTICLE_MENUS = {
  '220-1201': GET_ARTICLE_MENU_A_220_1201,
  '220-1202': GET_ARTICLE_MENU_A_220_1202,
  'Cloud+': GET_ARTICLE_MENU_CLOUD_CV0_004,
  'CySA+': GET_ARTICLE_MENU_CYSA_CS0_003,
  'DataSys+': GET_ARTICLE_MENU_DATASYS_DS0_001,
  'DATAX': GET_ARTICLE_MENU_DATAX_DX0_001,
  'Linux+': GET_ARTICLE_MENU_LINUX_XK0_006,
  'Network+': GET_ARTICLE_MENU_NETWORK_N10_009,
  'PenTest+': GET_ARTICLE_MENU_PENTEST_PT0_003,
  'Project+': GET_ARTICLE_MENU_PROJECT_PK0_005,
  'Security+': GET_ARTICLE_MENU_SECURITY_SY0_701,
  'Server+': GET_ARTICLE_MENU_SERVER_SK0_005
};

export const GET_ARTICLE_MENU = (SELECTED_BUNDLE) => {
  const menuFn = ARTICLE_MENUS[SELECTED_BUNDLE] || GET_ARTICLE_MENU_A_220_1201;
  let menu = [...menuFn()]; // Create a new array to avoid mutation
  
  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Articles (Testing)',
      icon_bg: '#E6E6FA',
      key: 'all_articles_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }
  
  return menu;
};




export const GET_TUTORIALS = () => {
  return [
    {
      title: `CompTIA Certification Exam Prep`,
      image: IMAGES.slide_1,
      description:
        'Ace your exam on the first try with this comprehensive study app! \nOver 10,000 practice questions and 5,000 flashcards to help you succeed in CompTIA certification exams.',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};













export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for CompTIA certification exams. I think you will find it very useful. Check it out " +
    app_url,
};


export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

// Display name for the Stripe product on user-facing invoices.
// Each brand build sets its own value (matches the product name in the Stripe dashboard).
export const STRIPE_PRODUCT_DISPLAY_NAME = 'CompTIA App - Exam Prep';

export const PAYWALL_COLUMNS = null;
export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;
